import { FullFormAction } from "../../../Engine/Core/Store/FullFormAction";
import { ImportEmployeesState } from "../../EmployeeServiceState";

import { ImportEmployeesActionType } from "./ImportEmployeesAction";

export function importEmployeesReducer(
    state: ImportEmployeesState | undefined,
    action: FullFormAction
): ImportEmployeesState | undefined {
    let nextState = state;

    if (action.type === ImportEmployeesActionType.BeginImport) {
        nextState = {
            ...nextState,
            showSideBar: true,
            initialState: action.payload.initialState,
            options: action.payload.options,
            resultDeferred: action.payload.deferredResult,
        };
    }
    if (action.type === ImportEmployeesActionType.EndImport) {
        nextState = {
            ...nextState,
            showSideBar: false,
            resultDeferred: undefined,
        };
    }

    return nextState;
}
